import React, {  useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Check, Copy, Trash2, Upload } from 'lucide-react';
import VideoShowcaseButton from './VideoShowcaseButton';
import VideoShowcaseStatusIndicator from './VideoShowcaseStatusIndicator';
import {toast} from "react-toastify";
import DownloadVideo from "./DownloadVideo";

const VideoShowcaseVideoCard = ({
                                  video,
                                  onPlay,
                                  onPause,
                                  onPublish,
                                  handleVideoAction,
                                }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  const handleMouseEnter = async () => {
    setShowOverlay(true);
    const video = videoRef.current;
    if (!video || video.readyState < 3) return;

    try {
      await video.play();
      setIsVideoPlaying(true);
      onPlay(video._id);
    } catch (error) {
      console.error('Error on hover play:', error);
    }
  };

  const handleMouseLeave = () => {
    setShowOverlay(false);
    const video = videoRef.current;
    if (!video) return;

    video.pause();
    setIsVideoPlaying(false);
    onPause();
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(video.uploadUrl);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleDownload = async () => {
    console.log(video, 'the video')
    setIsDownloading(true);
    try {
      const response = await fetch(video.uploadUrl, {
        method: 'GET',
        mode: 'cors'  // This is important for CORS requests
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${video.title || 'video'}.mp4`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        toast.error('Download failed');
      }
    } catch (err) {
      console.error('Download failed:', err);
      toast.error('Download failed');
    } finally {
      setIsDownloading(false);
    }
  };
  return (
      <div
          className="relative aspect-[9/16] rounded-lg shadow-md overflow-hidden"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
      >
        <video
            ref={videoRef}
            src={video.uploadUrl}
            className="w-full h-full object-cover"
            // muted
            loop
            playsInline
        />
        <AnimatePresence>
          {showOverlay && (
              <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent flex flex-col justify-between p-4"
              >
                <div className="flex flex-col space-y-4">
                  <div className="flex justify-between items-start">
                    <div className="space-y-2">
                      <VideoShowcaseStatusIndicator
                          isPublished={video.isPublishedOnYouTube}
                          platform="YouTube"
                      />
                      <VideoShowcaseStatusIndicator
                          isPublished={video.isPublishedOnTikTok}
                          platform="TikTok"
                      />
                      {/*<VideoShowcaseStatusIndicator*/}
                      {/*    isPublished={video.isPublishedOnInstagram}*/}
                      {/*    platform="Instagram"*/}
                      {/*/>*/}
                    </div>
                    <VideoShowcaseButton
                        variant="destructive"
                        size="sm"
                        onClick={() => handleVideoAction(video._id, 'delete', video.title)}
                    >
                      <Trash2 size={16} />
                    </VideoShowcaseButton>
                  </div>
                  <div className="flex items-center space-x-2 bg-black/40 backdrop-blur-sm rounded-lg p-2">
                    {/*<motion.button*/}
                    {/*    whileHover={{ scale: 1.1 }}*/}
                    {/*    whileTap={{ scale: 0.9 }}*/}
                    {/*    onClick={debouncedHandlePlayPause}*/}
                    {/*    className="p-1.5 rounded-full hover:bg-white/20 transition-colors"*/}
                    {/*    aria-label={isVideoPlaying ? 'Pause video' : 'Play video'}*/}
                    {/*>*/}
                    {/*  {isVideoPlaying ? (*/}
                    {/*      <Pause size={16} className="text-white" />*/}
                    {/*  ) : (*/}
                    {/*      <Play size={16} className="text-white" />*/}
                    {/*  )}*/}
                    {/*</motion.button>*/}
                    <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={handleCopyUrl}
                        className="p-1.5 rounded-full hover:bg-white/20 transition-colors"
                    >
                      {isCopied ? (
                          <Check size={16} className="text-green-400" />
                      ) : (
                          <Copy size={16} className="text-white" />
                      )}
                    </motion.button>
                    <DownloadVideo handleDownload={handleDownload} isDownloading={isDownloading}/>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-white text-sm font-semibold truncate">
                      {video.title}
                    </h3>
                    <p className="text-white/80 text-xs line-clamp-2">
                      {video.description}
                    </p>
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    {!video.isPublishedOnYouTube && (
                        <VideoShowcaseButton
                            size="xs"
                            variant="secondary"
                            onClick={() => onPublish(video, 'YouTube')}
                        >
                          <Upload size={12} className="mr-1 inline-block" /> YouTube
                        </VideoShowcaseButton>
                    )}
                    {!video.isPublishedOnTikTok && (
                        <VideoShowcaseButton
                            size="xs"
                            variant="secondary"
                            onClick={() => onPublish(video, 'TikTok')}
                        >
                          <Upload size={12} className="mr-1 inline-block" /> TikTok
                        </VideoShowcaseButton>
                    )}
                    {/*{!video.isPublishedOnInstagram && (*/}
                    {/*    <VideoShowcaseButton*/}
                    {/*        size="xs"*/}
                    {/*        variant="secondary"*/}
                    {/*        onClick={() => onPublish(video, 'Instagram')}*/}
                    {/*    >*/}
                    {/*      <Upload size={12} className="mr-1 inline-block" /> Instagram*/}
                    {/*    </VideoShowcaseButton>*/}
                    {/*)}*/}
                  </div>
                </div>
              </motion.div>
          )}
        </AnimatePresence>
      </div>
  );
};

export default VideoShowcaseVideoCard;
